import {gsap} from "gsap";

const animationLeave = (container) => {
    // console.log("SingleProject animation LEAVE");
    const tl = gsap.timeline({
        defaults : {
            duration: .5,
            ease: "power1.out",
        },
        delay:0
    });
    // si le menu de navigation mobile est ouvert, je dois le refermer avant de lancer l'animation
    // de fadeout.
    const body_el = document.body;
    const classMenuOpened = "mobile-nav-opened";
    const mask = container.querySelector("#project_image_mask");
    var delay_leave = '0';
    if(body_el.classList.contains(classMenuOpened)){
        const toggle_mobile_nav_button_el = document.querySelector("#burger-menu");
        // Create our event (with options)
        var evt = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        });
        toggle_mobile_nav_button_el.dispatchEvent(evt);
        delay_leave = ".3";
    }
    tl.to("#primary_section, #secondary_section", {alpha:0, y:-80, duration:.3});
    tl.to([body_el, mask], {backgroundColor:'#000000', duration: .5}, '-=.3');
    tl.to(container, {alpha:0, delay:delay_leave})
    return tl;
}

export default animationLeave;
